module.exports = __webpack_public_path__ + "static/media/testimonial (2).1c163bcb.png";